import React from 'react';
import settingsParams from '../../../settingsParams';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import s from './ContinueShopping.scss';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';

export enum ContinueShoppingDataHook {
  Root = 'ContinueShopping.root',
  Title = 'ContinueShopping.title',
  Link = 'ContinueShopping.link',
}

export enum ContinueShoppingPosition {
  emptyState = 'ContinueShoppingPosition.empty-state',
  headline = 'ContinueShoppingPosition.headline',
}

export function ContinueShopping({position}: {position: ContinueShoppingPosition}) {
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const {continueShopping, continueShoppingHref} = useControllerProps().navigationStore;
  const caption = getSettingsWithDefaults(settingsParams.CART_CONTINUE_SHOPPING_LINK);

  const onContinueShoppingClicked = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    continueShopping();
  };

  return (
    <div className={s.root} data-hook={ContinueShoppingDataHook.Root} data-position={position}>
      <a
        className={position === ContinueShoppingPosition.emptyState ? s.emptyStateLink : s.link}
        aria-label={caption}
        data-hook={ContinueShoppingDataHook.Link}
        href={continueShoppingHref}
        onClick={(e) => onContinueShoppingClicked(e)}>
        {caption}
      </a>
    </div>
  );
}
